import React, { useState } from "react"
import Box from "@material-ui/core/Box"
import Checkbox from "components/Forms/Checkbox"

/** Styles */
import styles from "./styles"

interface Props {
  handleUpdate: Function
  data: any
}

const Announcement: React.FC<Props> = ({ handleUpdate, data }) => {
  const { category, section } = styles()
  const [title] = useState("reports")

  return (
    <Box display="flex" alignItems="center" className={section}>
      <Box flex="3" className={category}>
        {title}
      </Box>
      <Box flex="1">
        {/* View */}
        <Checkbox
          label={null}
          value={Boolean(data?.reports_view)}
          onChange={() => handleUpdate("reports_view", Boolean(!data?.reports_view))}
        />
      </Box>
      <Box flex="1" />
      <Box flex="1" />
      <Box flex="1" />
    </Box>
  )
}
export default Announcement
